import { render, staticRenderFns } from "./tool-pullup.vue?vue&type=template&id=50d81733&scoped=true"
import script from "./tool-pullup.ts?vue&type=script&lang=ts&external"
export * from "./tool-pullup.ts?vue&type=script&lang=ts&external"
import style0 from "./tool-pullup.scss?vue&type=style&index=0&id=50d81733&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d81733",
  null
  
)

export default component.exports